import { render, staticRenderFns } from "./WayBack.vue?vue&type=template&id=bf568f54&scoped=true"
import script from "./WayBack.vue?vue&type=script&lang=js"
export * from "./WayBack.vue?vue&type=script&lang=js"
import style0 from "./WayBack.vue?vue&type=style&index=0&id=bf568f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf568f54",
  null
  
)

export default component.exports